import { render, staticRenderFns } from "./OwnerAddNewDialog.vue?vue&type=template&id=15163e39&"
import script from "./OwnerAddNewDialog.vue?vue&type=script&lang=js&"
export * from "./OwnerAddNewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports